//=require DW.SvgAnimation.js
//=require DW.TimelineItem.js

/*
 * This class checks if something should happen on scroll
 */
DW.ScrollEvents = function(svgAnimationElements, timelineElements, blockElements, banner) {
	this.scrolled = true;
	this.width = window.innerWidth;
	this.height = window.innerHeight;
	this.contentLoaded = false;

	// Create array of background images, that have nice methods to get scroll Infos
	this.svgAnimationElements = [];
	[].slice.call(svgAnimationElements).forEach(function(elem) {
		this.svgAnimationElements.push(new DW.SVGAnimationElement(elem));
	}.bind(this));

	this.timelineElements = [];
	[].slice.call(timelineElements).forEach(function(elem){
		this.timelineElements.push(new DW.TimelineElement(elem));
	}.bind(this));

	this.blockElements = [];
	[].slice.call(blockElements).forEach(function(elem){
		this.blockElements.push(new DW.ScrollAnimationItem(elem));
	}.bind(this));

	// Combine arrays that need same checks
	this.checkInVerticalView = this.svgAnimationElements.concat(this.timelineElements).concat(this.blockElements);
	this.checkBelowView = this.svgAnimationElements.concat(this.blockElements);

	this.banner = new DW.ScrollAnimationItem(banner);

	// scroll Logic happens inside request animation frame for better performance. window.onscroll only tells me, if a scroll occured
	window.addEventListener('scroll', function(ev) {
		if(this.scrolled === false) {
			this.scrolled = true;
			window.requestAnimFrame(this.checkScroll.bind(this));
		}
	}.bind(this));

	// Resize Event
	window.addEventListener('resize', function(ev) {
		this.width = window.innerWidth;
		this.height = window.innerHeight;
	}.bind(this));

	// initial checkScroll happens on load
};

DW.ScrollEvents.prototype = {
	initOnLoad: function() {
		this.contentLoaded = true;
		this.checkScroll();
	},

	checkScroll: function(ev) {
		if(this.contentLoaded === true) {
			scrollPos = getScrollPos();

			// Filter all elements that are in view and animate them
			var imagesInView = this.checkInVerticalView.filter(function(elem) {
				return elem.inVerticalView(scrollPos.scrollTop, this.height);
			}, this);
			imagesInView.forEach(function(elem) {
				elem.animateWhileInView(scrollPos.scrollTop, this.height);
			}.bind(this));

			// Filter all elements that are below view and reset them, if needed
			var imagesBelowView = this.checkBelowView.filter(function(elem) {
				return elem.belowView(scrollPos.scrollTop, this.height);
			}, this);
			imagesBelowView.forEach(function(elem) {
				elem.resetAnimation();
			}.bind(this));

			// Check if banner (main-header) is currently visible, mainly used for
			// section navigation
			if(this.banner.inVerticalView(scrollPos.scrollTop, this.height)) {
				document.body.classList.add("banner-visible");
			} else {
				document.body.classList.remove("banner-visible");
			}

			this.scrolled = false;
		}
	}
};
